/** The part of a dialog event this check reads. */
type DialogEvent = { target: unknown; currentTarget: unknown }

/**
 * A dialog's close handler that ignores the close of a dialog nested inside
 * it. React sends a `close` event up its own tree, so without this check a
 * Sign dialog that closes also closes the signing screen around it.
 */
export const ownCloseHandler =
  (onClose: () => void) =>
  (event: DialogEvent): void => {
    if (event.target !== event.currentTarget) return
    onClose()
  }
